import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import {
  Column,
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import React, { Component } from 'react';
import { BiX } from 'react-icons/bi';
import { BsCheck2 } from 'react-icons/bs';
import { all_information, loadingShow } from '../../../App';
import Message from '../../../utils/Message/Message';
import {
  AddAppComponent,
  DeleteAppComponent,
  EditAppComponent,
  getComponentS,
} from '../../../services/Components/ComponentServices';
interface IState {
  componentData: any;
}
interface IProps {}

export class ApplicationComponent extends Component<IProps, IState> {
  private grid: any;
  private switchStatus: SwitchComponent = new SwitchComponent({});
  public validationRule: Object = { required: true };
  constructor(prop: IProps) {
    super(prop);
    this.state = {
      componentData: [],
    };
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    'Search',
  ];
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  toolbarClick(args: any) {
    if (args.item.id === 'refresh') {
      this.getComponent();
    }
    if (this.grid && args.item.id === 'gridAC_excelexport') {
      this.grid.excelExport();
    }
  }
  SavePointDelete(obje: any) {
    loadingShow(true);
    const obj = JSON.stringify({
      ID: obje[0].ID,
    });
    DeleteAppComponent(obj)
      .then((result: any) => {
        this.getComponent();
        Message.success('Delete Successfully');
        loadingShow(false);
      })
      .catch((err: any) => {
        Message.error('Delete Failed');
        loadingShow(false);
      });
  }
  SavePointAdd(data: any) {
    let isComponent = this.state.componentData.find(
      (x: any) => x.component_name === data.component_name
    );
    if (isComponent !== undefined) {
      Message.error('Same component already exists!');
      this.getComponent();
      return false;
    }
    loadingShow(true);
    AddAppComponent(data)
      .then((result: any) => {
        this.getComponent();
        Message.success('Edit Successfully');
        loadingShow(false);
      })
      .catch((err: any) => {
        Message.error('Edit Failed');
        loadingShow(false);
      });
  }
  SavePointEdit(data: any) {
    let isComponent = this.state.componentData.find(
      (x: any) => x.ID !== data.ID && x.component_name === data.component_name
    );
    if (isComponent !== undefined) {
      Message.error('Same component already exists!');
      this.getComponent();
      return false;
    }
    loadingShow(true);
    const obj = {
      ...data,
    };
    EditAppComponent(obj)
      .then((result: any) => {
        this.getComponent();
        Message.success('Edit Successfully');
        loadingShow(false);
      })
      .catch((err: any) => {
        Message.error('Edit Failed');
        loadingShow(false);
      });
  }
  componentDidMount() {
    this.getComponent();
  }
  getComponent = async () => {
    const model = await getComponentS().then((result: any) => {
      return result.data;
    });
    this.setState({ componentData: model });
  };
  actionBeginComponent(args: any) {
    args.data = {
      ...args.data,
      organization_id: all_information.company_id?.toString(),
      app: 'UWORK',
      created_by: all_information.user_id,
      CreatedDate: new Date(),
      status: this.switchStatus?.checked,
    };
    if (args.action === 'add') {
      this.SavePointAdd(args.data);
    } else if (args.action === 'edit') {
      this.SavePointEdit(args.data);
    } else if (args.requestType === 'delete') {
      this.SavePointDelete(args.data);
    }
  }
  private istatustemplate(args: any) {
    let isChecked = args.status;
    return (
      <div>
        {isChecked ? (
          <BsCheck2 size={20} color='green' />
        ) : (
          <BiX size={20} color='red' />
        )}
      </div>
    );
  }
  private isStatustemplateEditing(args: any) {
    return (
      <SwitchComponent
        checked={args.status}
        ref={(scope: SwitchComponent) => (this.switchStatus = scope)}
      />
    );
  }
  render() {
    return (
      <div>
        <GridComponent
          id='gridAC'
          editSettings={this.editOptions}
          ref={(g) => (this.grid = g)}
          toolbar={this.toolbarOptions}
          dataSource={this.state.componentData}
          height='calc(-220px + 100vh)'
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          allowExcelExport={true}
          showColumnChooser
          toolbarClick={this.toolbarClick.bind(this)}
          actionBegin={this.actionBeginComponent.bind(this)}
          gridLines='Both'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='component_name'
              headerText='Component Name'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='component_description'
              validationRules={this.validationRule}
              headerText='Description'
            />
            <ColumnDirective
              field='status'
              headerText='Status'
              textAlign='Left'
              template={this.istatustemplate.bind(this)}
              editTemplate={this.isStatustemplateEditing.bind(this)}
              width={'30px'}
              minWidth={'30px'}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              Page,
              ColumnChooser,
              ExcelExport,
              ColumnMenu,
              Resize,
              Group,
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}

export default ApplicationComponent;
